<template>
  <v-autocomplete
    :value="value"
    outlined
    :multiple="multiple"
    :chips="multiple"
    :loading="loading"
    :label="label"
    :hint="hint"
    persistent-hint
    :items="items"
    item-value="id"
    item-text="name"
    hide-details="auto"
    clearable
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: "Select Classroom",
    },
    hint: {
      type: String,
      required: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      classrooms: [],
    };
  },
  created() {
    this.fetchClassrooms();
  },
  computed: {
    items() {
      return this.classrooms.map(classroom => ({
        id: classroom.id,
        name: classroom.roomNumber,
      }));
    },
  },
  methods: {
    async fetchClassrooms() {
      const response = await this.$axios.get("/classroom", {
        params: { size: 1000 },
      });
      // save classrooms
      this.classrooms = response.data.content ?? [];
    },
  },
};
</script>
